export enum BusinessPromotionEnum {
  PROMO_12_MESES_DMR = 'PROMO12MESESDMR',
  PROMO_6_MESES_DMR = 'PROMO6MESESDMR',
  PROMO_6_MESES = 'PROMO6MESES',
  PROMO_2_MESES = 'PROMO2MESES',
}
